/* gsap-reveal.js (no jump) */
(function(){
  var MODE = document.documentElement.dataset.gsapRevealMode || 'scroll'; // 'scroll' | 'load'
  var DEFAULTS = { distance: 32, duration: 0.6, delay: 0, ease: 'power3.out' };

  function dirToXY(dir, dist){
    switch((dir||'up').toLowerCase()){
      case 'down': return {x:0, y:-dist};
      case 'left': return {x:-dist, y:0};
      case 'right': return {x:dist, y:0};
      default: return {x:0, y:dist}; // up
    }
  }

  function prime(el){ // set initial "from" state up-front to avoid jump
    if (el.__gsapPrimed) return;
    var d  = +(el.dataset.distance || DEFAULTS.distance);
    var xy = dirToXY(el.dataset.reveal, d);
    gsap.set(el, { autoAlpha: 0, x: xy.x, y: xy.y, filter: 'blur(6px)', scale: 0.98 });
    el.__gsapPrimed = true;
  }

  function animateToNeutral(el){
    var duration = +(el.dataset.duration || (DEFAULTS.duration*1000))/1000;
    var delay    = +(el.dataset.delay || DEFAULTS.delay)/1000;
    var ease     = el.dataset.ease || DEFAULTS.ease || 'power3.out';
    gsap.to(el, {
      autoAlpha: 1, x: 0, y: 0, filter: 'blur(0px)', scale: 1,
      duration, delay, ease, clearProps: 'transform,filter'
    });
  }

  function runScroll(root){
    gsap.registerPlugin(ScrollTrigger);
    gsap.utils.toArray((root||document).querySelectorAll('.reveal')).forEach(function(el){
      prime(el);
      var once = (el.dataset.once ?? 'true') !== 'false';
      ScrollTrigger.create({
        trigger: el,
        start: 'top 80%',
        onEnter: function(){ animateToNeutral(el); if (once) this.disable(); },
        once
      });
    });

    // Optional group stagger
    gsap.utils.toArray('[data-reveal-group]').forEach(function(group){
      var items = group.querySelectorAll('.reveal');
      if (!items.length) return;
      var st = +(group.dataset.stagger || 0.12);
      items.forEach(prime);
      ScrollTrigger.create({
        trigger: group,
        start: 'top 85%',
        once: true,
        onEnter: function(){
          items.forEach(function(el, i){
            if (!el.dataset.delay) el.dataset.delay = (i * st * 1000);
            animateToNeutral(el);
          });
        }
      });
    });
  }

  function runLoad(){
    var vh = window.innerHeight;
    document.querySelectorAll('.reveal').forEach(function(el){
      prime(el);
      var r = el.getBoundingClientRect();
      if (r.top < vh && r.bottom > 0) animateToNeutral(el);
    });
  }

  function init(root){
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      document.querySelectorAll('.reveal').forEach(function(el){ gsap.set(el, {clearProps:'all', autoAlpha:1}); });
      return;
    }
    if ((document.documentElement.dataset.gsapRevealMode||'scroll') === 'load') runLoad(); else runScroll(root);
  }

  window.addEventListener('load', function(){ init(); });

  if (window.Shopify && window.Shopify.designMode) {
    document.addEventListener('shopify:section:load', function(e){ init(e.target); });
    document.addEventListener('shopify:section:select', function(e){ init(e.target); });
  }
})();